export const COMMERCES_INITIAL_FORM = {
  nom_commerce: "",
  categorie: "",
  siret: "",
  description_commerce: "",
  tags: "",
  contact_nom: "",
  contact_fonction: "",
  tel: "",
  mail: "",
  website: "",
  facebook: "",
  instagram: "",
  logo_url: "",
  photo_url: "",
  adresse: "",
  code_postal: "",
  ville: "",
  // Nouveau champ front uniquement
  gps_coordinates: "",

  // Champs envoyés au back
  gps_lat: "",
  gps_lng: "",
  moyens_paiement: "",
  accessibilite: "",
  services: "",
  is_active: true,
};

export const COMMERCES_STATUS_OPTIONS = [
  {
    value: "all",
    label: "Tous",
    description: "Afficher tous les commerces.",
  },
  {
    value: "active",
    label: "Publiés",
    description: "Visibles sur le site public.",
  },
  {
    value: "inactive",
    label: "Brouillons",
    description: "Masqués du site public.",
  },
];

export const COMMERCES_LOGO_OPTIONS = [
  {
    value: "all",
    label: "Tous",
  },
  {
    value: "yes",
    label: "Avec logo",
  },
  {
    value: "no",
    label: "Sans logo",
  },
];

export const COMMERCES_GPS_OPTIONS = [
  {
    value: "all",
    label: "Tous",
  },
  {
    value: "yes",
    label: "Avec GPS",
  },
];

export const COMMERCES_LIMIT_OPTIONS = [12, 24, 48, 96];

export const COMMERCE_CATEGORY_SUGGESTIONS = [
  "Boulangerie",
  "Restaurant",
  "Commerce alimentaire",
  "Artisan",
  "Coiffure",
  "Beauté",
  "Santé",
  "Services",
  "Garage",
  "Immobilier",
  "Hébergement",
];

export const COMMERCES_FORM_HELPERS = [
  "Le nom du commerce est le seul champ obligatoire.",
  "Un logo et une photo rendent la fiche plus attractive.",
  "Les coordonnées GPS permettent d’afficher le commerce sur une carte.",
];

export const COMMERCES_MEDIA_CATEGORY_DEFAULT = "commerces";